import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { FavoriteOccupationsFacade } from '@cpd-app/state/favorite-occupations/favorite-occupations.facade';
import { AccountCreationPromptService } from '@cpd-app/core-module/services';

@Component({
  selector: 'cpd-occupation-favorite-button',
  templateUrl: './occupation-favorite-button.component.html',
  styleUrls: ['./occupation-favorite-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OccupationFavoriteButtonComponent implements OnInit {
  @Input() public onetCode: string;
  @Input() public jobId = 0;

  public isOccupationInFavorites$: Observable<boolean>;
  public shouldDisable$: Observable<boolean>;

  constructor(
    private favoriteOccupationsFacade: FavoriteOccupationsFacade,
    private accountCreationPromptService: AccountCreationPromptService
  ) {}

  public ngOnInit(): void {
    if (!this.onetCode) {
      throw new TypeError("'onetCode' is required");
    }

    this.isOccupationInFavorites$ = this.favoriteOccupationsFacade
      .isOccupationInFavorites$(this.onetCode, this.jobId ?? 0)
      .pipe(shareReplay(1));

    this.shouldDisable$ = combineLatest([
      this.isOccupationInFavorites$,
      this.favoriteOccupationsFacade.isFavoriteOccupationsAtMaxCount$
    ]).pipe(
      map(
        ([isOccupationInFavorites, isFavoriteOccupationsAtMaxCount]) =>
          !isOccupationInFavorites && isFavoriteOccupationsAtMaxCount
      )
    );
  }

  public onRemoveFavoriteOccupation(event: MouseEvent): void {
    event.stopPropagation();
    this.favoriteOccupationsFacade.removeFavoriteOccupation(
      this.onetCode,
      this.jobId ?? 0
    );
  }

  public onAddFavoriteOccupation(
    event: MouseEvent,
    shouldDisable: boolean
  ): void {
    event.stopPropagation();
    if (shouldDisable) {
      return;
    }

    this.accountCreationPromptService.openAccountCreationDialog(
      'favorite-occupation'
    );

    this.favoriteOccupationsFacade.addFavoriteOccupation(
      this.onetCode,
      this.jobId ?? 0
    );
  }
}
